var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBrokenImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 48,
    viewBox: "0 0 60 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_183_1206)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.0008 8.99988C54.0008 5.69051 51.3102 2.99988 48.0008 2.99988H13.0883L16.8852 5.99988H48.0008C49.6602 5.99988 51.0008 7.34051 51.0008 8.99988V24.8811L44.6539 18.5343C43.1914 17.0718 40.8195 17.0718 39.3477 18.5343L36.4414 21.4405L38.8133 23.3155L41.4758 20.653C41.7664 20.3624 42.2445 20.3624 42.5352 20.653L51.0008 29.1186V32.9343L54.0008 35.3061V8.99988ZM27.9008 29.9811L27.0008 30.8811L20.6539 24.5343C19.1914 23.0718 16.8195 23.0718 15.3477 24.5343L9.0008 30.8811V15.0655L6.0008 12.6936V38.9999C6.0008 42.3093 8.69142 44.9999 12.0008 44.9999H46.9133L43.1164 41.9999H20.1195L30.2633 31.8561L27.8914 29.9811H27.9008ZM24.882 32.9999L15.882 41.9999H12.0008C10.3414 41.9999 9.0008 40.6593 9.0008 38.9999V35.1186L17.4664 26.653C17.757 26.3624 18.2352 26.3624 18.5258 26.653L24.882 32.9999Z",
    fill: "#4B5469"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: 2,
    x2: 58,
    y2: 46,
    stroke: "#4B5469",
    strokeWidth: 4,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_183_1206"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrokenImage);
export default __webpack_public_path__ + "static/media/brokenImage.a417ff88725d96d1edf50938b15b87a5.svg";
export { ForwardRef as ReactComponent };